import { resizeCanvas, renderScreen } from './renderer.js';
import { state } from './state.js';
import { processKey, processBackspace, processEnter, processArrowKey } from './inputHandler.js';
import { fps } from './setup.js';

 // Ensure fonts are loaded before initial render.
 document.fonts.ready.then(() => {
    resizeCanvas();
    setupIntervals();
  });
  window.addEventListener('resize', resizeCanvas);

  // Capture keyboard input.
document.addEventListener('keydown', async (e) => {
    if (state.waitingForKeyPress) {
        // If waiting for a key press, resolve the promise and stop further processing.
        state.waitingForKeyPress = false; // Reset the flag
        if (state.keyPressResolve) {
            state.keyPressResolve(e.key); // Resolve the promise with the key pressed
            state.keyPressResolve = null; // Clear the resolve function
        }
        return;
    }

    if (e.key === "Escape") {
        if (state.running) {
            state.running = false;
        }
    }
    
    if (!state.ready)
        return;
    // Append printable characters (converted to uppercase).
    if (e.key.length === 1 && !e.ctrlKey && !e.metaKey) {
        processKey(e.key);
    } else if (e.key === "Backspace") {
        processBackspace();
        e.preventDefault(); // Prevent default browser behavior.
    } else if (e.key === "Enter") {
        processEnter();
    } else if (e.key === "ArrowUp" || e.key === "ArrowDown" || e.key === "ArrowLeft" || e.key === "ArrowRight") {
        // Handle up arrow key.
        processArrowKey(e);
        e.preventDefault(); // Prevent default browser behavior.
    }
});

const setupIntervals = () => {
  // Blink the cursor every 350ms.
  setInterval(() => { state.showCursor = !state.showCursor; }, 350);
  // Render screen at 50fps.
  setInterval(renderScreen, 1000 / fps);
};